import { HttpErrorResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { I18nService } from '@personal-area/global/i18n';
import { ApiFormService } from '@personal-area/global/form-validation/services';
import { ModalComponent } from '@personal-area/global/modal';
import { AccountsFacade } from '@personal-area/global/accounts/services';
import { Account } from '@personal-area/global/accounts/models';
import { filter } from 'rxjs/operators';
import {
  AccountDescriptionPopupComponent,
} from '../components/account-description-popup/account-description-popup.component';
import { AddDemoFundsPopupComponent } from '../components/add-demo-funds-popup/add-demo-funds-popup.component';
import { RenameAccountPopupComponent } from '../components/rename-account-popup/rename-account-popup.component';


@Injectable({ providedIn: 'root' })
export class AccountActionsService {
  constructor(
    private dialog: MatDialog,
    private formService: ApiFormService,
    private _accountsFacade: AccountsFacade,
    private _i18nService: I18nService,
  ) {
  }

  public rename(account: Account) {
    this.dialog.open(RenameAccountPopupComponent, {
      data: {
        userId: account.userId,
        accountId: account.id,
        name: account.name,
      },
      panelClass: 'regular-popup-container',
      direction: this._i18nService.isRtl ? 'rtl' : 'ltr',
      autoFocus: false,
    }).afterClosed().pipe(filter(n => !!n))
      .subscribe((name: string) => {
        // update account
        const accountToUpdate = Object.assign({}, account);
        accountToUpdate.name = name;
        this._accountsFacade.updateAccount(account.id, accountToUpdate);
      });
  }

  public addDescription(account: Account) {
    this.dialog.open(AccountDescriptionPopupComponent, {
      data: {
        userId: account.userId,
        accountId: account.id,
        comment: account.userComment,
      },
      panelClass: 'regular-popup-container',
      direction: this._i18nService.isRtl ? 'rtl' : 'ltr',
      autoFocus: false,
    }).afterClosed().pipe(filter(c => !!c))
      .subscribe((comment: string) => {
        // update account
        const accountToUpdate = Object.assign({}, account);
        accountToUpdate.userComment = comment;
        this._accountsFacade.updateAccount(account.id, accountToUpdate);
      });

  }

  public onAddDemoFundsClick(account: Account) {
    this.dialog.open(AddDemoFundsPopupComponent, {
      data: {
        account: account,
      },
      panelClass: 'regular-popup-container',
      direction: this._i18nService.isRtl ? 'rtl' : 'ltr',
      autoFocus: false,
    })
      .afterClosed().pipe(filter(a => !!a))
      .subscribe((data: { amount?: number; error?: HttpErrorResponse }) => data.amount ?
        this.onAddDemoFundsSuccess() :
        this.formService.defaultFormError(data.error),
      );
  }

  public onAddDemoFundsSuccess() {
    this.dialog.open(ModalComponent, {
      data: {
        title: 'add-demo-funds.title',
        text: 'add-demo-funds.text',
        btn: 'add-demo-funds.btn',
      },
      panelClass: ['regular-popup-container', 'modal-outer-wrapper'],
      direction: this._i18nService.isRtl ? 'rtl' : 'ltr',
    });
  }
}
